import i18n from '@/lang/i18n'

export default [{
  path: '/admin/apply/BigDataScreen',
  name: 'ApplyBigDataScreen',
  component: () => import('@/views/apply/device/bigDataScreen'),
  meta: {
    title: i18n.t('router.device.data_screen'),
    headType: 0,
    auth: true
  }
}, {
  path: '/admin/apply/scmConfig',
  name: 'scmConfig',
  component: () => import('@/views/apply/device/scmConfig'),
  meta: {
    title: i18n.t('router.device.supply_chain_config'),
    headType: 0,
    auth: true
  }
}, {
  path: '/admin/apply/selectionStore',
  name: 'selectionStore',
  component: () => import('@/views/apply/device/selectionStore'),
  meta: {
    title: i18n.t('router.device.inventory_center'),
    headType: 0,
    auth: true
  }
}, {
  path: '/admin/apply/deviceType',
  name: 'deviceType',
  component: () => import('@/views/apply/device/deviceType'),
  meta: {
    title: i18n.t('router.device.device_category'),
    headType: 0,
    auth: true
  }
}, {
  path: '/admin/apply/deviceList',
  name: 'deviceList',
  component: () => import('@/views/apply/device/deviceList'),
  meta: {
    title: i18n.t('router.device.device_list'),
    headType: 0,
    auth: true
  }
}, {
  path: '/admin/apply/deviceAlarmType',
  name: 'deviceAlarmType',
  component: () => import('@/views/apply/device/deviceAlarmType'),
  meta: {
    title: i18n.t('router.device.alarm_type'),
    headType: 0,
    auth: true
  }
}, {
  path: '/admin/apply/deviceAlarm',
  name: 'deviceAlarm',
  component: () => import('@/views/apply/device/deviceAlarm'),
  meta: {
    title: i18n.t('router.device.alarm_record'),
    headType: 0,
    auth: true
  }
}, {
  path: '/admin/apply/screenConfig',
  name: 'screenConfig',
  component: () => import('@/views/apply/device/screenConfig'),
  meta: {
    title: i18n.t('router.device.screen_setting'),
    headType: 0,
    auth: true
  }
}]



// WEBPACK FOOTER //
// ./src/router/apply/device.js